<template>
<div>

	<!-- page-heading -->
	<page-heading show="false" showBack="false" pageTitle="HEADER-INDUSTRY-CONTENTS"></page-heading>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<div class="columns" v-if="!isLoading">


		<div class="col-main">

			<alert type="info" :closable="true" class="infoSpecial">{{ $t('MSG-BOX-INDUSTRIEPARTNER-MAINTAIN_CONTENTS') }}</alert>

			<tabs type="boxed" size="normal" @click.native="tabClicked()">

				<tab-item v-for="(catalogPage, index) in catalogPagesTrimmed" :key="index" :label="catalogPage.name"  v-if="catalogPage.catalogPageElements[0] && catalogPage.catalogPageElements[0].contentElement">

					<content-element ref="contentElement" :isReadOnly="isApproved(catalogPage)" :contentElement="catalogPage.catalogPageElements[0].contentElement"></content-element>

					<div class="columns">

						<div class="column"></div>

	                    <div class="column is-6 is-narrow has-text-right">
							<!-- :class="[{'is-disabled': isApproved(catalogPage)}]" -->
							<custom-button type="blue" icon="icon-ak-speichern" name="PAGE_BUTTON-SAVE" :loading="isSaving" @click.native="submitForm(catalogPage)" :class="[{'is-disabled': isApproved(catalogPage)}]"></custom-button>
							<custom-button :loading="isApproving" :class="[{'is-disabled is-success': isApproved(catalogPage) }, '']" icon="icon-ak-freigaben2" @click.native="submitForm(catalogPage, true)" :name="isApproved(catalogPage) ? 'BTN-INDUSTRY-IS_APPROVED' : 'BTN-INDUSTRY-APPROVE'"></custom-button>
						</div>

						<div class="column"></div>

					</div>

				</tab-item>

			</tabs>


		</div>


	</div>


</div>
</template>


<script>
import contentElement from '../../catalog/incl-catalogPageElementContentElement';


export default {

	components: {
		contentElement
	},


	data() {
		return {
			isSaving: false,
			isLoading: false,
			isApproving: false,
			catalogPages: []
		}
	},

    computed: {

		catalogPagesTrimmed() {

			var arr = this.catalogPages;
			for(var i=0; i < arr.length; i++) {
				arr.splice(i+1%2, 1);
			}

			return arr;

		},

		catalogPageElementStatus() {

			return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_ELEMENT_STATUS');

		},

		catalogPageStatus() {

			return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_STATUS');

		}


	},

	created() {

		this.fetchData();

		setTimeout(function() {
			this.isLoading = false;
		}, 500);

	},

	mounted() {



	},

	methods: {

        tabClicked() {

            $('.contentWrapper').flowtype({
                minFont : 2,
                fontRatio: 20
            });

        },


		isApproved(page) {

			// not approved if status of page is "created" or "ready"
			if(page.status == this.catalogPageStatus.CREATED.id || page.status != this.catalogPageStatus.READY.id) {

				return true;
			}

			return false;

			/*
			if(page.catalogPageElements[0] && (page.catalogPageElements[0].status == this.catalogPageStatus.EDITED.id ||page.catalogPageElements[0].status == this.catalogPageElementStatus.APPROVED.id || page.catalogPageElements[0].status == this.catalogPageElementStatus.PRINT_APPROVED.id)) {

				return true;
			}

			return false;
			*/

		},

		fetchData() {

			this.isLoading = true;
			var self = this;
			var url = this.$config.api + 'catalogPage?include=catalogPage.catalog,catalogPage.catalogPageElements,catalogPageElement.contentElement,contentElement.contentElementData,contentElementData.assets,contentElementDataAsset.asset,contentElementData.type,contentElement.type&filters[catalog.isActive]=1&filters[manufacturer]='+self.$store.getters.getUser.manufacturer.id;

            this.axios.get(url)
                .then(function(res) {
                      self.catalogPages = res.data.catalogPage;
					  console.log("DATA: ", res.data.catalogPage);
					  self.isLoading = false;
                })
                .catch(function(err) {

                    console.log(err);
                });

		},

		submitForm(catalogPage, approve) {

			this.isSaving = true;
			var self = this;

			if(approve == true) {
				this.isApproving = true;
				catalogPage.status = this.catalogPageStatus.EDITED.id;
			}

			this.axios.put(this.$config.api+'catalogPage/'+catalogPage.id, catalogPage)
				.then(function(response) {
					self.isSaving = false;
					self.isApproving = false;

					if(approve == true) {
						self.$notify.success({content: self.$t('MSG-SUCCESS-INDUSTRY-DATA_APPROVEMENT_SENT')});
					} else {
						self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE')});
					}

					// self.submitFormStatus();
				}).catch(function(error) {
					self.isApproving = false;
					self.isSaving = false;
					self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});
					console.log(error);
				});


		}

	}

}
</script>


<style scoped>
	.is-6 {
		min-width:70%;
	}
</style>

<style>
	.tabs ul.tab-list li a span {
	    white-space: nowrap !important;
	    overflow: hidden !important;
	    text-overflow: ellipsis !important;
	    max-width: 180px !important;
	}
</style>
